export const checkOldPlan = (planKey: string) =>
  ["pro54327", "pro11vzm"].includes(planKey)
    ? "oldpro"
    : ["proplus04563", "proplus11pqg"].includes(planKey)
      ? "oldpro+"
      : "normal";
